export default __webpack_public_path__ + "static/media/assinatura-1920x1080Tiny.9ef44c64.png";